module.exports = __webpack_public_path__ + "static/video-movie-sp-77ecb36cf72568a68c5bfc3a15ec1d45.mp4";